<template>
  <ContentSection
    :spacing="isSustainabilityArticleWithSidebar ? 'sm-margin' : 'default'"
  >
    <Container indent="none">
      <Swiper
        :slides-per-view="1"
        :space-between="20"
        :pagination="{
          clickable: true,
        }"
        :autoplay="{
          delay: 10000,
          disableOnInteraction: false,
        }"
        :loop="true"
        :speed="1500"
        :allow-touch-move="true"
        class="image-slider relative"
        :modules="[SwiperAutoplay, SwiperPagination]"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="image in data.images" :key="image.id">
          <figure>
            <ImageDownloadable
              v-if="image.image"
              class="aspect-[88/60] size-full select-none"
              :class="
                checkIfPortraitImage(image.image)
                  ? 'object-contain bg-[#ABABAB]/25'
                  : 'object-cover'
              "
              :image="image.image"
              :aspect="88 / 60"
              :downloadable="image.downloadable"
              :style="`object-position: ${image.focus_css};`"
            />

            <figcaption
              v-if="image.caption"
              class="mt-5 max-w-text text-sm text-[#ABABAB] sm:mt-6"
            >
              {{ image.caption }}
            </figcaption>
          </figure>
        </SwiperSlide>
        <!-- stay centered to the image -->
        <div class="absolute inset-x-0 top-0 z-10 aspect-[176/60]">
          <SwiperButtons
            ref="swiperButtons"
            class="absolute inset-x-0 bottom-0 translate-y-1/2 text-white sm:inset-x-3"
            :reach-beginning="false"
            @prev="swiper.slidePrev()"
            @next="swiper.slideNext()"
          />
        </div>
      </Swiper>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

// SWIPER
let swiper = {}
const swiperButtons = ref(null)

const onSwiper = (swiperElement) => {
  swiper = swiperElement
}

const checkIfPortraitImage = (img) => {
  return img.height >= img.width
}
</script>

<style lang="scss">
.image-slider {
  .swiper-pagination {
    @apply absolute top-0 pt-[68.18%] sm:-translate-y-10 -translate-y-7 pointer-events-none;
  }
  .swiper-pagination-bullet {
    @apply bg-white w-6 rounded-full h-1 transition-colors opacity-100 pointer-events-auto;
  }
  .swiper-pagination-bullet-active {
    @apply bg-blue-800;
  }
}
</style>
